<template>
  <title-card title="Statements">
    <div class="font-italic font-weight-bold">
      * When a statement is available, it will show here
    </div>
    <filter-table
      primary-key="id"
      empty-text="No Documents added."
      :fields="fields"
      :items="documents"
      :slots="templates"
      :show-filter="false"
      :stickyHeader="true"
    >
      <template slot="name" slot-scope="record">
        <a :href="record.row.item.link" target="_blank" class="no-text-decoration">
          {{ record.value }}
        </a>
      </template>
      <template slot="submitted" slot-scope="record">
        {{record.value | date}}
      </template>
    </filter-table>
  </title-card>
</template>

<script>
import TitleCard from '@/components/utils/TitleCard';
import DocumentsLegend from '@/components/utils/DocumentsLegend';
import FilterTable from '@/components/utils/FilterTable';
import UploadMultipleFiles from '@/components/utils/upload/UploadMultipleFiles';
import SentFilesModal from '@/components/documents/SentFilesModal';

export default {
  name: 'StatementsDocuments',
  components: {
    DocumentsLegend,
    TitleCard,
    FilterTable,
    UploadMultipleFiles,
    SentFilesModal,
  },
  props: {
    loan: Object,
  },
  data() {
    return {
      modalRecord: {},
      documents: [],
      fields: [
        { key: 'name', sortable: true },
        { key: 'submitted', sortable: true },
      ],
      templates: [
        { key: 'name' },
        { key: 'submitted' },
      ],
    };
  },
  mounted() {
    this.documents = this.loan.documents.statements || [];
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/deals/documents/StatementsDocuments.vue